export default "__VITE_ASSET__e4e76cc8__"